twc.currencyCountryPopup = (function(){

	var hasCurrencyLink 	= $(".currencyLink").length > 0;

	if ( !hasCurrencyLink) {
		return false;
	}
	
// 	================================
// 	 CurrencyCountry Modal Functionality
// 	================================

// 	DOM references
		$overlay 	= $("#currency-country-window-container"),
		$container	= $overlay.children("#currency-country-window"),
		$content 	= $container.children("#pui-container"),
// 	DOM Fragments
		$spinner 	= $("<img id='quick-spinner' src='//whitecompany.scene7.com/is/content/whitecompany/Icons/spinner.gif' >"),
// 	Functions
		addSpinner = function() {
			$container.append( $spinner ).fadeIn("fast");
		},

		removeSpinner = function() {
			$spinner.remove();
		},

		getHTML = function( url ) {
	        console.log('url => '+ url);
			$.ajax( url, {

				complete: function( data ) {
					insertHTML( data.responseText );
				},
				type: 'POST',
				error: function( data, status ) {
					console.error( status );
				}
			});

		},

		insertHTML = function( html ) {

			removeSpinner();
			$content.html( html );
			ACC.common.refreshScreenReaderBuffer();
			countryContent.initialize();
            PaymentImagesUtil.setInitialPaymentImage();
		},

		closeModal = function() {
			$container.fadeOut( function() {

				$content.empty();
				$overlay.fadeOut( "fast" );
				ACC.common.refreshScreenReaderBuffer();
			});
		},

		openCurrencyCountryPopup = function( href ) {
			$overlay.show();
			addSpinner();
			getHTML( href );
		};

// 	--------------
// 	Event Bindings
// 	--------------

// 	On currencyCountry popup <a>
	$( document ).on( "click", "a.currencyLink", function( e ) {
		openCurrencyCountryPopup( $( e.currentTarget ).attr( "data-link" ) );
		return false;
	});

// 	CurrencyCountryPopup Close
	$("#window-currency-country-close").on( "click", closeModal );


	
	return {};
})();

CurrencyUtil={};

CurrencyUtil.getCurrencyBlock=function(item)
{
	var  radioSet=" ";
	var twoCurrencies=false;
	if(item.indexOf("-")>=0)
	{
	var currencies=	item.split("-");
	$.each( currencies, function(i,currency) {
		radioSet=	radioSet+CurrencyUtil.splitCurrency(currency,twoCurrencies);
		twoCurrencies=true;
	});
	$currencySpan.html(radioSet);
	}
	else if(item.indexOf("and")>=0)
		{
		radioSet=CurrencyUtil.splitCurrency(item,twoCurrencies);
		$currencySpan.html(radioSet);
		}
}

CurrencyUtil.splitCurrency=function(currencyString,twoCurrencies)
{
	if(currencyString.indexOf("and")>=0)
	{
		var currencies=	currencyString.split("and");
		return  " <label for='currencyRadio' class='radio-container'><input type='hidden' name='code' value='"+currencies[1].trim()+"'/> "+currencies[0]+currencies[1]+" </label>";
	}
	}

PaymentImagesUtil={};

PaymentImagesUtil.showImage=function(isos,selectedCountry){
    return isos && isos.indexOf(selectedCountry)!==-1? true:false
}

PaymentImagesUtil.showIdeal=function(selectedCountry){
    var idealIsos = $("#ideal-payment").attr('data-iso');
    return PaymentImagesUtil.showImage(idealIsos,selectedCountry);
}

PaymentImagesUtil.getIsocodeSelected=function(){
    return $("#country-selector").find(":selected").val();
}

PaymentImagesUtil.toggleClass=function(id){
    $('#' + id).toggleClass('hidden');
}

PaymentImagesUtil.notHiddenClass=function(id){
    return !$('#' + id).hasClass("hidden");
}

PaymentImagesUtil.resetPaymentImagesToDefault=function(){
  if(PaymentImagesUtil.notHiddenClass('ideal-payment')){
      PaymentImagesUtil.toggleClass('ideal-payment');
  }
  if(!PaymentImagesUtil.notHiddenClass('default-img-payment')){
		PaymentImagesUtil.toggleClass('default-img-payment');
  }
  if(PaymentImagesUtil.notHiddenClass('all-payments')){
        PaymentImagesUtil.toggleClass('all-payments');
  }
}
PaymentImagesUtil.dynamicImage=function(isoCode,paymentType,all){
	if ($("#all-payments").attr('src') !== '/_ui/desktop/common/images/payment-logos-all.svg') {
		$("#all-payments").attr("src", "/_ui/desktop/common/images/payment-logos-all.svg");
	}
}

PaymentImagesUtil.setInitialPaymentImage=function(){
    var selectedCountry = PaymentImagesUtil.getIsocodeSelected();
    var isIdeal =PaymentImagesUtil.showIdeal(selectedCountry);
	if (isIdeal) {
		PaymentImagesUtil.toggleClass('ideal-payment');
		PaymentImagesUtil.toggleClass('default-img-payment');
	}
}

PaymentImagesUtil.refreshPaymentImage=function() {
    PaymentImagesUtil.resetPaymentImagesToDefault();
    PaymentImagesUtil.setInitialPaymentImage();
}

var countryContent = (function(){

	var $countrySelector,

		createDOMReferences = function() {
			$currencySpan			= $('#currencySpan');
			$countrySelector		= $('#country-selector');
			$cancel					= $('#Cancel');

            $cancel.on( "click", closeModal );
		},

		showHideCurrency= function(ev)
		{
			PaymentImagesUtil.refreshPaymentImage();
			var obj=$(ev.target).find(':selected').data('curr');
			CurrencyUtil.getCurrencyBlock(obj);
		},
		initialize = function() {
			if (typeof closeModal != "undefined") {
                createDOMReferences();
            }
			$("#country-selector").on("change" ,showHideCurrency).change();
			ACC.common.refreshScreenReaderBuffer();
		};
		return {
			initialize: initialize
		}
})();

$(function () {
	var modal = $('#Modal');
	var modalContent = $('.modal-box-content');
	modal.css('display', 'block');
	countryContent.initialize();
	$(modal).on('click', function (event) {
		if (!$(event.target).closest(modalContent).length) {
			modal.css('display', 'none');
		}
	});
	$(".modal-close").on( "click", function (event) {
		if (modal) {
			modal.css('display', 'none');
		}
	});

});
